import { useTranslation } from 'react-i18next'
import { Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function UpgradePrompt({ feature }: { feature: string }) {
  const { t } = useTranslation()

  return (
    <div className="border-primary/30 bg-primary/5 flex flex-col items-center gap-3 rounded-lg border border-dashed p-6 text-center">
      <div className="bg-primary/10 flex size-10 items-center justify-center rounded-full">
        <Sparkles className="text-primary size-5" />
      </div>
      <div>
        <p className="text-sm font-medium">{feature}</p>
        <p className="text-muted-foreground mt-1 text-xs">{t('ai.upgradeDescription')}</p>
      </div>
      <Button size="sm" className="mt-1">
        {t('ai.upgradeCta')}
      </Button>
    </div>
  )
}
